// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import YuqueFilledSvg from "@fishx/icons-svg/es/asn/YuqueFilled";
import FishxIcon from '../components/FishxIcon';

var YuqueFilled = function YuqueFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: YuqueFilledSvg
  }));
};

YuqueFilled.displayName = 'YuqueFilled';
export default React.forwardRef(YuqueFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/YuqueFilled.js
// module id = 4419
// module chunks = 0